/**
 * @generated SignedSource<<78d5ceacba9196f933c21f3c2809b332>>
 * @relayHash 9ab22e0311c2d196d8ea6a8875f54d8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 31f89f98bec086f3150ee3033180e3e628c57a424b65b52474a696ed7c4c4c8d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomerDetailsCustomerDetailsPageCsmQuery } from './CustomerDetailsCustomerDetailsPageCsmQuery.graphql';

import isAssetsFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerContextRelayprovider';
import isAssetsFastFollowEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerCtxFastFollowsRelayprovider';

const node: PreloadableConcreteRequest<CustomerDetailsCustomerDetailsPageCsmQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "31f89f98bec086f3150ee3033180e3e628c57a424b65b52474a696ed7c4c4c8d",
    "metadata": {},
    "name": "CustomerDetailsCustomerDetailsPageCsmQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerContextRelayprovidertsx": isAssetsFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerCtxFastFollowsRelayprovidertsx": isAssetsFastFollowEnabled_provider
    }
  }
};

export default node;
